import React, { ReactNode } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import Loading from "components/app/Loading";

interface MapWrapperProps {
  children: ReactNode;
}

const LIBRARIES: "places"[] = ["places"];

const MapWrapper = ({ children }: MapWrapperProps) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
    libraries: LIBRARIES,
    version: "weekly",
    language: "es",
    region: "AR",
  });

  if (loadError) {
    return <div>Error cargando Google Maps API</div>;
  }

  if (!isLoaded) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default MapWrapper;
